import React, { useContext } from "react";

import classNames from "classnames";
import PropTypes from "prop-types";
import AccordionContext from "react-bootstrap/AccordionContext";
import { useAccordionToggle } from "react-bootstrap/AccordionToggle";

import { ReactComponent as IconAccordionExpand18 } from "../../icons/icon/18/a-icon-accordeon-expand-18.svg";
import { ReactComponent as IconAccordionMinimize18 } from "../../icons/icon/18/a-icon-accordeon-minimize-18.svg";

import "./stateAwareAccordionToggle.scss";

const StateAwareAccordionToggle = ({
  callback = () => {},
  children,
  className = "",
  eventKey,
  iconMinimize = <IconAccordionMinimize18 />,
  iconMaximize = <IconAccordionExpand18 />,
}) => {
  const currentEventKey = useContext(AccordionContext);
  const toggleOnClick = useAccordionToggle(eventKey, () => {
    callback(eventKey);
  });
  const active = currentEventKey === eventKey;

  return (
    <div
      className={classNames("state-aware-accordion-toggle", { "state-aware-accordion-toggle--active": active }, className)}
      onClick={toggleOnClick}
      onKeyDown={(event) => {
        if (event.key === "Enter") {
          toggleOnClick();
          event.stopPropagation();
        }
      }}
      role="button"
      tabIndex="0"
    >
      <div>{children}</div>
      <div className="state-aware-accordion-toggle__icon">{ active ? iconMinimize : iconMaximize }</div>
    </div>
  );
};

StateAwareAccordionToggle.propTypes = {
  callback: PropTypes.func,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  eventKey: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  iconMaximize: PropTypes.oneOfType([PropTypes.object]),
  iconMinimize: PropTypes.oneOfType([PropTypes.object]),
};

export default StateAwareAccordionToggle;
